export default __webpack_public_path__ + "static/media/jigglypuff.201c7b41.png";